import activeJobService from '@/http/services/activejob'
import store from '../../../store'
export default {
  updateFollowOnJobsPriority ({commit}, data) {
    return activeJobService.updateDriverActiveJobsPriority(store.state.apiUrl, data).then((response) => {
      return response.data
    })
  },
  getDriverActiveJobs ({ commit }, taxiId) {
    return activeJobService.getDriverActiveJobs(store.state.apiUrl, taxiId).then((booking) => {
      commit('setDriverActiveJobs', booking.data)
    })
  }
}
